import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API, headers: { "Content-Type": "application/json" } });
export { http };

export const subscribeNewsletter = (data) => http.post("/newsletter/subscribe", data).then(r => r.data);
export const submitContact      = (data) => http.post("/contact", data).then(r => r.data);
export const submitBooking      = (data) => http.post("/booking-inquiry", data).then(r => r.data);
export const submitRelease      = (data) => http.post("/release-request", data).then(r => r.data);
export const getTestimonials    = ()     => http.get("/testimonials").then(r => r.data);
export const getBIIDTestimonial = ()     => http.get("/testimonials/biid").then(r => r.data);
export const recordPageview     = (data) => http.post("/analytics/pageview", data).then(r => r.data);
export const getAdminTraffic    = (key, days = 30) => http.get(`/admin/traffic?key=${encodeURIComponent(key)}&days=${days}`).then(r => r.data);
